import { useFormContext, useController } from "react-hook-form";
import { InputLabel } from "../Inputs";
import { PaziaQuill } from "./PaziaQuill";

export interface PaziaFromQuillProps {
  name: string;
  onChange?: (content: string) => void;
  label?: string;
  className?: string;
  required?: boolean;
  readOnly?: boolean;
  placeholder?: string;
}

export const PaziaFromQuill = ({
  name,
  label,
  required,
  className = "",
  onChange,
  readOnly,
  placeholder,
}: PaziaFromQuillProps): JSX.Element => {
  const { control } = useFormContext();

  const { field } = useController({
    name,
    control,
  });

  const onChangeHandler = (content: string) => {
    field.onChange(content);
    if (onChange) onChange(content);
  };

  return (
    <div className={className}>
      <InputLabel label={label} required={required} name={name} />
      <PaziaQuill
        onChange={onChangeHandler}
        value={field.value}
        readOnly={readOnly}
        placeholder={placeholder}
      />
    </div>
  );
};
